var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortingArrow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.36603 0.499999C6.98113 -0.166668 6.01888 -0.166667 5.63397 0.5L0.437822 9.5C0.0529222 10.1667 0.534048 11 1.30385 11L11.6962 11C12.466 11 12.9471 10.1667 12.5622 9.5L7.36603 0.499999Z",
    fill: "#ffffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingArrow2);
export default __webpack_public_path__ + "static/media/sortingArrow2.01d139ca32d056eaa95efe893ad7412c.svg";
export { ForwardRef as ReactComponent };